import React, { Component } from 'react';

/**
 * Placeholder for a header element that is being loaded.
 * Shows a single big placeholder bar.
 */
class HeaderLoadPlaceholder extends Component {
    render() {
        return (
            <div className="ph-item">
                <div className="ph-col-12">
                    <div className="ph-row">
                        <div className="ph-col-12 big darker"></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderLoadPlaceholder;